import { SET_USER_ACCESSIBILITY } from './useraccessibility.type';

export const setUserAccessibility = (set_user_accessibility) => {
  return {
    type: SET_USER_ACCESSIBILITY,
    payload: set_user_accessibility
  };
};
